export const communicateOptions = [
  { title: '得意意識がある', value: 'Fluently' },
  { title: 'どちらかといえば得意意識がある', value: 'CanBeUsed' },
  { title: 'どちらかといえば苦手意識がある', value: 'HardlyUsable' },
  { title: 'できない', value: 'CanNot' },
  { title: 'したくない', value: 'DoNotWantTo' },
];
